import React from "react";
import { NavLink } from "react-router-dom";
import { Shield, Clock, User } from "lucide-react";

const items = [
  { to: "/app", icon: Shield, label: "Inicio", testid: "nav-home" },
  { to: "/app/historial", icon: Clock, label: "Historial", testid: "nav-history" },
  { to: "/app/perfil", icon: User, label: "Perfil", testid: "nav-profile" },
];

export const BottomNav = () => {
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 h-20 backdrop-blur-xl bg-[#121212]/85 border-t border-white/10 flex justify-around items-center px-4 z-50"
    >
      {items.map(({ to, icon: Icon, label, testid }) => (
        <NavLink
          key={to}
          to={to}
          end={to === "/app"}
          data-testid={testid}
          className={({ isActive }) =>
            `flex flex-col items-center gap-1 px-4 py-2 rounded-lg transition-all ${
              isActive ? "text-[#00E5FF]" : "text-[#A1A1AA] hover:text-white"
            }`
          }
        >
          {({ isActive }) => (
            <>
              <Icon size={22} strokeWidth={isActive ? 2.4 : 1.8} />
              <span className="text-[10px] font-mono uppercase tracking-[0.18em]">{label}</span>
              {isActive && <span className="absolute bottom-1 w-1 h-1 rounded-full bg-[#00E5FF] glow-blue" />}
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
};
